import Vue from 'vue';
import Vuex from "vuex";


Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        isLoggedIn: false,
        isLoading:false,
        product:{},
        userToken:null,
        user:{},
        regType:0,
        userData:{},
        jobDetails:{},
        location:"",
        SGBList:[],
        CatList:[],
        category:"Open",
        printpmt:false,
        registrationDetails:{},
        regId:'00000000-0000-0000-0000-000000000000',
        pmtObject:{
                    pmtPurpose:"",
                    BoardID:'00000000-0000-0000-0000-000000000000',
                    TransType: 'Registration'
                },
        PFStatus:true,
        applicationObj:{},
        experienceFlag:false
    },
    actions: {
        login: function ({ commit }, user) {
            commit("LOGIN_SUCCESS", user);
        },
        logout: function ({ commit }) {
            commit("LOGOUT");
        },
        setRegType: function({commit}, regtyp){
            commit("REGTYPE", regtyp);
        },
        setUserData: function({commit}, userData){
            commit("USERDATA", userData);
        },
        setLocation: function({commit}, location){
            commit("LOCATION",location);
        },
        setJobDetails: function({commit}, jobData){
            commit('SET_JOB_DETAILS', jobData);
        },
        setSGBList: function({commit}, sgbList){
            commit('SET_SGB_LIST', sgbList);
        },
        setCatList: function({commit}, catlist){
            commit('SET_CAT_LIST', catlist);
        },
        setPrintPmt: function({commit}, flag){
            commit('SET_PRINT_PMT', flag);
        },
        setRegistrationDetails: function({commit}, data){
            commit('SET_REGISTRATION', data);
        },
        setRegID: function({commit}, regId){
            commit('SET_REGID', regId);
        },
        setPmtObject({commit}, pmtObject){
            commit('SET_PMTOBJ', pmtObject);
        },
        setPFStatus({commit}, pfStatus){
            commit('SET_PFSTATUS', pfStatus);
        },
        setApplicationObj({commit}, appObj){
            commit('SET_APPOBJ', appObj);
        },
        setExperienceFlag({commit}, expFlg){
            commit('SET_EXPFLG', expFlg);
        }
    },
    mutations: {
        LOGIN: function (state) {
            state.pending = true;
        },
        LOGIN_SUCCESS: function (state,user) {
            state.isLoggedIn = true;
            state.pending = false;
            state.userToken = user.token;
            state.user = user.user;
        },
        LOGOUT: function (state) {
            
            state.isLoggedIn = false;
            state.userToken = null;
            state.user = {};
        },
        REGTYPE: function(state, regtyp){
            state.regType = regtyp;
        },
        USERDATA: function(state, userData){
            state.userData = userData;
        },
        LOCATION: function(state, location){
            state.location = location;
        },
        SET_JOB_DETAILS: function(state, jobData){
            state.jobDetails = jobData;
        },
        SET_SGB_LIST: function(state, sgbList){
            state.SGBList = sgbList;
        },
        SET_CAT_LIST: function(state, catList){
            state.CatList = catList;
        },
        SET_PRINT_PMT:function(state,flag){
            state.printpmt=flag;
        },
        SET_REGISTRATION:function(state,data){
            state.registrationDetails = data;
        },
        SET_REGID:function(state,regId){
            state.regId = regId;
        },
        SET_PMTOBJ(state, pmtObject){
            state.pmtObject = pmtObject;
        },
        SET_PFSTATUS(state, pfStatus){
            state.PFStatus = pfStatus;
        },
        SET_APPOBJ:function(state,appObj){
            state.applicationObj = appObj;
        },
        SET_EXPFLG:function(state, expflg){
            state.experienceFlag=expflg;
        }
    },
    getters: {
        isLoggedIn: state => {
            return state.isLoggedIn;
        },
        authToken: state =>{
            return state.userToken;
        },
        loggedUser: state => {
            return state.user;
        },
        getJobDetails: state =>{
            return state.jobDetails;
        },
        getLocation: state =>{
            return state.location;
        },
        getRegTyp:  state =>{
            return state.regType
        },
        getUserData:  state =>{
            return state.userData
        },
        UserName: state => {
            return state.user.UserName;
        },
        isLoading: state => {
            return state.isLoading;
        },
        getSGBList: state =>{
            return state.SGBList;
        },
        getCatList: state =>{
            return state.CatList;
        },
        getPrintPmt: state =>{
            return state.printpmt;
        },
        getRegistrationDetails: state =>{
            return state.registrationDetails;
        },
        getRegId: state=>{
            return state.regId;
        },
        getPmtObj: state=>{
            return state.pmtObject;
        },
        getPFStatus: state=>{
            return state.PFStatus;
        },
        getAppObj:state =>{
            return state.applicationObj;
        },
        getExperienceFlag:state =>{
            return state.experienceFlag;
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js